/**
 * Merges GET /api/afas/openstaand/list-items field options into static field definitions.
 */
export const mergeVerzoekFieldOptions = (fields = [], optionsByField = {}) =>
    fields.map((field) => {
        if (field.type !== 'select') {
            return field;
        }

        const options = optionsByField[field.id];
        if (!Array.isArray(options) || options.length === 0) {
            return field;
        }

        return {
            ...field,
            options: options.map((option) => ({
                value: String(option.value ?? ''),
                label: String(option.label ?? option.value ?? ''),
                ...(option.selector != null && option.selector !== ''
                    ? { selector: String(option.selector) }
                    : {}),
            })),
        };
    });
